module.exports = __webpack_public_path__ + "img/whatsapp.283c596.png";